<template>
    <div class="app-body"
         id="view"
         v-if="communication">
        <div class="header-padding header-info"
             v-if="hasPermissionTo(['view communication'])">
            <div class="row">
                <div class="col-lg-4 col-md-6 col-12">
                    <div class="box b-a no-effect">
                        <div class="box-header">
                            <div class="d-flex flex-row px-3 justify-content-between">
                                <div>
                                    <b>Communication Info</b>
                                </div>

                                <div class="width-200 fixed">
                                    <!-- Archive communication -->
                                    <el-button class="opaq pull-right"
                                               style="padding: 7px 12px;border-radius: 8px;font-size: 15px !important;"
                                               type="danger"
                                               v-if="hasPermissionTo('archive communication')"
                                               :loading="loading_archive"
                                               :disabled="loading_archive"
                                               @click="archiveCommunication(communication_id)">
                                        Delete
                                    </el-button>
                                </div>
                            </div>
                            <div class="pl-3 pr-3">
                            </div>
                        </div>
                        <div class="box-divider m-a-0"></div>
                        <div class="box-body">
                            <communication-info :communication="communication"
                                                :verbose="true">
                            </communication-info>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8 col-md-6 col-12"
                     v-if="communication && communication.type == CommunicationTypes.CALL">
                    <div class="box border no-effect" v-if="communication.aloAiBotCall">
                        <div class="box-body">
                            <h5 class="text-dark mx-4 my-3">AloAi Agent Call</h5>
                            <div class="px-4 pb-3">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-horizontal b-b mb-3" v-if="communication.aloAiBotCall.recording_url">
                                            <div class="form-group row mb-0">
                                                <label class="form-control-label col-5">Recording:</label>
                                                <div class="col-7 d-flex align-items-center">
                                                    <span class="text-dark-greenish">
                                                        <el-popover trigger="click"
                                                                    popper-class="v-c"
                                                                    v-model="aloAiRecordingPopoverOpen"
                                                                    placement="right"
                                                                    :open-delay="100"
                                                                    :append-to-body="true">
                                                            <el-button slot="reference"
                                                                       size="small"
                                                                       type="text text-dark-greenish m-0 p-0">
                                                                <i class="fa fa-play"></i>
                                                                <span class="ml-1">Play Recording</span>
                                                            </el-button>
                                                            <template v-if="aloAiRecordingPopoverOpen">
                                                                <div class="d-flex flex-column width-300 fixed">
                                                                    <div class="row">
                                                                        <div class="col-12">
                                                                            <audio class="w-100" controls>
                                                                                <source :src="communication.aloAiBotCall.recording_url" type="audio/mpeg">
                                                                                Your browser does not support the audio element.
                                                                            </audio>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row mt-2">
                                                                        <div class="col-12">
                                                                            <a class="btn btn-block btn-primary _600"
                                                                               title="Download"
                                                                               target="_blank"
                                                                               role="button"
                                                                               download
                                                                               :href="communication.aloAiBotCall.recording_url">
                                                                                Download recording
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </el-popover>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-horizontal b-b mb-3" v-if="communication.aloAiBotCall.started_at">
                                            <div class="form-group row mb-0">
                                                <label class="form-control-label col-5">Started:</label>
                                                <div class="col-7 d-flex align-items-center">
                                                    <span>{{ communication.aloAiBotCall.started_at | fixCommunicationDateTime }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-horizontal b-b mb-3" v-if="communication.aloAiBotCall.ended_at">
                                            <div class="form-group row mb-0">
                                                <label class="form-control-label col-5">Ended:</label>
                                                <div class="col-7 d-flex align-items-center">
                                                    <span>{{ communication.aloAiBotCall.ended_at | fixCommunicationDateTime }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-horizontal b-b mb-3" v-if="communication.aloAiBotCall.duration_in_seconds">
                                            <div class="form-group row mb-0">
                                                <label class="form-control-label col-5">Duration:</label>
                                                <div class="col-7 d-flex align-items-center">
                                                    <span>{{ communication.aloAiBotCall.duration_in_seconds | fixDuration }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6" v-if="communication.aloAiBotCall.transcript">
                                        <div class="form-horizontal">
                                            <div class="form-group row mb-0">
                                                <label class="form-control-label col-12 mb-2">Transcript:</label>
                                                <div class="col-12">
                                                    <div class="text-muted" style="white-space: pre-wrap;" v-html="formattedTranscript"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="box b-a no-effect" :class="{'mt-3': communication.aloAiBotCall}">
                        <div class="box-body">
                            <el-tabs v-model="tab_name"
                                     class="pl-2 pr-2">
                                <el-tab-pane label="Inbox Snapshot"
                                             name="ring_group_snapshot">
                                    <template v-if="showRingGroupSnapShot">
                                        <div class="text-center text-md _400">
                                            <p class="mb-0">This is a snapshot of the inbox at the point when this call arrived<span v-if="communication.metadata.ring_group_snapshot.length > 0 && communication.metadata.ring_group_snapshot[0].created_at"> {{ communication.metadata.ring_group_snapshot[0].created_at | fixCommunicationDateTime }}</span>.</p>
                                        </div>
                                        <ring-group-routing-display :ring_group="ringGroup"
                                                                    :layers="communication.metadata.ring_group_snapshot">
                                        </ring-group-routing-display>
                                    </template>
                                    <template v-else>
                                        <div class="text-center text-md _400">
                                            <p class="mb-0">
                                                {{ snapshotDescription }}
                                            </p>
                                        </div>
                                    </template>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                    </div>
                    <div class="box border no-effect mt-3">
                        <div class="box-body">
                            <h5 class="text-dark mx-4 my-3">Call Quality</h5>
                            <template v-if="showNetworkLogs">
                                <network-logs-display :callIssues="Object.values(communication.call_quality_summary)"
                                                      :user="communication.user"/>
                            </template>
                            <template v-else>
                                <div class="d-flex align-items-center _600 border-top px-4 pt-3">
                                    <img src="/assets/images/app-icons/icon-check-circle-green.svg"
                                         class="mr-2">
                                    No call quality issues detected
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="box border no-effect mt-3" v-if="communication.call_timeline && communication.call_timeline.length > 0">
                        <div class="box-body">
                            <h5 class="text-dark mx-4 my-3">Call Timeline (Beta)</h5>
                            <call-timeline :timeline="communication.call_timeline"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-backtop target="html"
                    ref="backtop"
                    :bottom="20"
                    :right="20">
        </el-backtop>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import auth from '../auth'
import CommunicationSummary from "../components/communication-summary"
import CallTimeline from "../components/network-logs/call-timeline"
import NetworkLogsDisplay from "../components/network-logs/network-logs-display"
import RingGroupRoutingDisplay from "../components/ring-groups/ring-group-routing-display"
import * as CommunicationDirection from '../constants/communication-direction'
import * as CommunicationDispositionStatus from '../constants/communication-disposition-status'
import * as CommunicationTypes from '../constants/communication-types'
import * as CreatorTypes from '../constants/creator-types'
import { chargebee_mixin, scroll_mixin } from '../mixins'

export default {
    components: {CommunicationSummary, NetworkLogsDisplay, RingGroupRoutingDisplay, CallTimeline},

    mixins: [chargebee_mixin, scroll_mixin],

    props: {
        communication_id: {
            required: true
        }
    },

    data() {
        return {
            auth: auth,
            loading_archive: false,
            communication: null,
            tab_name: 'ring_group_snapshot',
            CommunicationTypes,
            CommunicationDispositionStatus,
            aloAiRecordingPopoverOpen: false,
        }
    },

    computed: {
        ...mapState(['ring_groups']),
        ...mapState('cache', ['current_company']),

        ringGroup() {
            if (this.communication.ring_group_id) {
                return this.getRingGroup(this.communication.ring_group_id)
            }

            if (this.communication.metadata && this.communication.metadata.added_ring_group_id) {
                return this.getRingGroup(this.communication.metadata.added_ring_group_id)
            }

            return null
        },

        showRingGroupSnapShot() {
            return this.ringGroup
                && this.hasRingGroupSnapshot
                && (this.isInboundCall || this.isCreatedFromSequence)
        },

        isInboundCall() {
            return this.communication.direction === CommunicationDirection.INBOUND
        },

        hasRingGroupSnapshot () {
            return this.communication.metadata?.ring_group_snapshot
        },

        isCreatedFromSequence() {
            return this.communication.creator_type === CreatorTypes.CREATOR_TYPE_WORKFLOW
        },

        snapshotDescription () {
            if (!this.ringGroup) {
                return 'This call does not have an inbox.'
            }

            if (!this.isInboundCall) {
                return 'Outbound calls don\'t have an inbox snapshot.'
            }

            if (this.communication.disposition_status2 === CommunicationDispositionStatus.DISPOSITION_STATUS_ABANDONED_NEW) {
                return 'Abandoned calls don\'t have an inbox snapshot.'
            }

            return 'This communication does not have a snapshot.'
        },

        showNetworkLogs() {
            return Object.values(this.communication?.call_quality_summary).length > 0
        },

        formattedTranscript() {
            if (!this.communication?.aloAiBotCall?.transcript) {
                return ''
            }
            return this.communication.aloAiBotCall.transcript
                .replace(/(Agent:)/g, '<strong>$1</strong>')
                .replace(/(User:)/g, '<strong>$1</strong>')
        }
    },

    created() {
        VueEvent.listen('update_communication', (data) => {
            // check communication update matches
            if (this.communication && this.communication.id === data.id) {
                // update communication
                data = _.merge(this.communication, data)
                this.communication = data
            }
        })
    },

    mounted() {
        this.setTitle()
        if (this.hasPermissionTo('view communication')) {
            this.getCommunication(this.communication_id)
        }
    },

    methods: {
        setTitle() {
            axios.get('/get-statics')
                .then(res => {
                    let name = res.data.name
                    this.setPageTitle('Communication - ' + name)
                })
                .catch(err => {
                    this.setPageTitle('Communication - Aloware')
                    console.log(err)
                    this.$root.handleErrors(err.response)
                })
        },

        getRingGroup(id) {
            if (!id) {
                return null
            }
            let found = this.ring_groups.find(ring_group => ring_group.id === id)
            if (found) {
                return found
            }

            return null
        },

        getCommunication(communication_id) {
            axios.get('/api/v1/communication/' + communication_id, {
                mode: 'no-cors',
            }).then(res => {
                this.communication = res.data
            }).catch(err => {
                console.log(err)
                this.$root.handleErrors(err.response)
            })
        },


        archiveCommunication(communication_id) {
            this.$confirm('Deleting this communication will remove it from all reports and graphs. Do you want to proceed?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                customClass: 'width-500 fixed',
                type: 'warning'
            }).then(() => {
                this.deleteCommunication(communication_id)
            }).catch(() => {
                // archive canceled
            })
        },

        deleteCommunication(communication_id) {
            this.loading_archive = true
            axios.delete(`/api/v1/communication/${communication_id}`).then(res => {
                this.loading_archive = false
                // trigger event manually to remove the communication from the list
                VueEvent.fire('delete_communication', {id: communication_id})
                // send an notification to inform user the communication is archived
                this.$notify({
                    offset: 95,
                    title: 'Communication',
                    message: 'Communication deleted successfully.',
                    type: 'success',
                    showClose: true
                })
                // go back
                this.goBack()
            }).catch(err => {
                this.loading_archive = false
                this.$root.handleErrors(err.response)
            })
        },

        reset() {
            this.communication = null
        },
    },


    watch: {
        $route({params, query}) {
            this.reset()
            if (this.hasPermissionTo('view communication')) {
                this.getCommunication(this.communication_id)
            }
        }
    },

    beforeRouteEnter(to, from, next) {
        auth.check().then((res) => {
            if (res.data.user.is_reseller) {
                // redirect to account management portal if the company is a reseller
                next({name: 'Account Management Portal'})
            } else {
                next()
            }
        }).catch((err) => {
            next({name: 'Login', query: {redirect: to.fullPath}})
        })
    }
}
</script>
